var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.507 17.4l-3.398-3.405c-.677-.675-1.797-.655-2.498.047L13.9 15.758l-.338-.189c-1.08-.6-2.56-1.423-4.117-2.984C7.884 11.02 7.062 9.535 6.46 8.45a17.38 17.38 0 00-.184-.33l1.149-1.15.565-.567c.701-.703.72-1.826.045-2.504L4.64.494c-.677-.676-1.798-.656-2.5.047l-.958.965.026.027c-.32.41-.589.884-.789 1.394-.184.487-.298.95-.35 1.415C-.38 8.07 1.32 11.477 5.932 16.1c6.376 6.39 11.514 5.907 11.735 5.883a5.729 5.729 0 001.416-.356 5.518 5.518 0 001.387-.788l.02.019.97-.952c.7-.703.72-1.826.046-2.505z"}));
}

Phone.defaultProps = {"fill":"currentColor","viewBox":"0 0 22 22"};

module.exports = Phone;

Phone.default = Phone;
